import { useRef } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { absUrl } from "@/lib/api";
import { Reveal } from "@/lib/motion";

export default function Showreel({ project, onOpen }) {
    const vidRef = useRef(null);
    if (!project) return null;

    return (
        <section data-testid="showreel" className="px-5 md:px-10 pt-10 md:pt-16 pb-2">
            <Reveal>
                <div className="flex items-baseline justify-between border-b border-line pb-4">
                    <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-inkdim">Showreel</p>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-inkdim">Sound on</p>
                </div>
            </Reveal>

            <div className="flex justify-center">
                <motion.div
                    className="group relative overflow-hidden bg-ink mt-8 aspect-[9/16] w-full md:w-auto md:h-[80vh]"
                    onViewportEnter={() => vidRef.current?.play().catch(() => {})}
                    onViewportLeave={() => vidRef.current?.pause()}
                >
                    <video
                        ref={vidRef}
                        data-testid="showreel-video"
                        src={absUrl(project.video_url)}
                        poster={absUrl(project.thumbnail_url)}
                        muted
                        loop
                        playsInline
                        preload="none"
                        className="absolute inset-0 h-full w-full object-contain"
                    />
                    <button
                        data-testid="showreel-play"
                        onClick={() => onOpen(project)}
                        aria-label="Play showreel with sound"
                        className="absolute inset-0 flex items-center justify-center cursor-pointer"
                    >
                        <span className="inline-flex items-center gap-2 md:gap-3 border border-paper/60 text-paper px-4 py-2.5 md:px-7 md:py-4 text-[9px] md:text-[11px] font-bold uppercase tracking-[0.24em] backdrop-blur-sm bg-ink/20 hover:bg-paper hover:text-ink transition-colors duration-300">
                            <Play size={12} /> Play with sound
                        </span>
                    </button>
                    <div className="absolute bottom-0 inset-x-0 flex items-end justify-between p-4 md:p-6 pointer-events-none">
                        <h3 className="font-display font-extrabold uppercase tracking-tight text-paper text-lg md:text-2xl">
                            {project.title}
                        </h3>
                        <span className="text-[10px] uppercase tracking-[0.2em] text-paper/70">Brands · Films · Sets</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
